import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b2edc324"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-menu" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Contact Us", -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "FAQs", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "section-start" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "My Account", -1))
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx, _cache) {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", null, [
      _createElementVNode("li", null, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = $event => (_ctx.goToContactUs()))
        }, _hoisted_3)
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = $event => (_ctx.goToFAQ()))
        }, _hoisted_5)
      ]),
      _createElementVNode("li", _hoisted_6, [
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = $event => (_ctx.signOut()))
        }, _hoisted_8)
      ])
    ])
  ], 512)), [
    [_vShow, _ctx.show]
  ])
}